import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
} from "react-router-dom";

import { ToastProvider } from "./GlobalComponent/ToastMessage/ToastContext";
import { AuthProvider } from "./Service/AuthService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navigation from "./Navigation";
import { Provider } from 'react-redux';
import store from "./ReduxSlice/Store";
function App() {
  useEffect(() => {
    const savedColors = JSON.parse(localStorage.getItem("appColors"));
    const backgroundImage = localStorage.getItem("backgroundImage");
  
    if (savedColors) {
      applyColors(savedColors);
    }
  
    if (backgroundImage) {
      setTimeout(() => {
        applyBackgroundImages(backgroundImage);
      }, 100); // Ensures styles apply properly
    }
  }, []);
  
  // ==================backgroundimage==============
  const applyBackgroundImages = (images) => {
    const container = document.getElementById("sims_main_dash");
    if (container) {
      container.style.backgroundImage = `url(${images})`;
      container.style.backgroundSize = "cover";
      container.style.backgroundPosition = "center";
      container.style.backgroundRepeat = "no-repeat";
      container.style.height = "100vh";
      container.style.overflowY = "auto";
      container.style.backgroundAttachment = "fixed"; // Optional: if you want the background to stay fixed
    }
  };
  // Apply colors to CSS variables in :root
  const applyColors = (colors) => {
    Object.keys(colors).forEach((key) => {
      const cssVarName = `--${key}-color`;
      document.documentElement.style.setProperty(cssVarName, colors[key]);
    });
  };
  
  return (
    <Router>
      <AuthProvider>
        <Provider store={store}>
          <ToastProvider>
            <Navigation />
            <ToastContainer style={{ zIndex: 10999 }} />
          </ToastProvider>
        </Provider>
      </AuthProvider>
    </Router>
  );
}

export default App;
